import React from 'react'
import ReportStandardUserListMobileTab from './ReportStandardUserListMobileTab'
import { buildReportChargesUserMobileCardSections } from './reportChargesUserMobileCardModel'

export default function ReportChargesMobileTab(props) {
  return (
    <ReportStandardUserListMobileTab {...props} buildCardSections={buildReportChargesUserMobileCardSections} />
  )
}
